import { observable, reaction } from "mobx";
import { AUTOSAVE_DELAY } from "../../constants/editor";

import QuizObjectPatchable from "./quiz-object-patchable";

interface IQuizObjectChunk {
    content: string;
    _id: string | undefined;
    remove: Function;
    setContent: Function;
    setType: Function;
    chunkType: string;
    linkedCardID: string | undefined;
}


class QuizObjectChunk extends QuizObjectPatchable {
    @observable _id: string | undefined = undefined;
    @observable content: string = "";
    @observable chunkType: string = "text";
    @observable metadata: any;
    @observable isNew: boolean = false;
    @observable quiz_object: any;
    @observable linkedCardID: string | undefined = undefined;

    constructor(quizObjectId: string, quizObjectStatus: Map<string, any>, chunk: any) {
        super(quizObjectId, quizObjectStatus);

        console.log(chunk);

        if (chunk.isNew === true) {
            this.isNew = true;
        }
        this._id = chunk._id;
        this.content = chunk.content;
        this.metadata = chunk.metadata;
        this.chunkType = chunk.chunkType;
        if (chunk.linkedCardID) {
            this.linkedCardID = chunk.linkedCardID;
        }
        reaction(
            () => {
                return this.content;
            },
            () => {
                this.persist();
            },
            { delay: AUTOSAVE_DELAY }
        );

    }

    public setContent(newContent: string) {
        this.content = newContent;
    }

    public setType(newType: string) {
        this.chunkType = newType;
    }


    /**
     * This omits certain fields that shouldn't be sent to the backend.
     */
    public chunkJSON() {
        const { linkedCardID, metadata, deleted, status, isNew, statusMessage, quizObjectId, quiz_object, quizObjectStatus, ...retval } = this;
        return retval;
    }

    /*
     *   This is the public api to remove a chunk from the quiz object.
     */
    async remove() {
        await this._patchDelete({
            deleteChunk: this.chunkJSON()
        });
    }

    /*
     *   This is the public api to restore a deleted chunk from the quiz object.
     */
    async restore() {
        await this._patchRestore({
            chunk: this.chunkJSON()
        });
    }


    /*
     *   This is the public api to persist a chunk to the quiz object.
     */
    async persist() {
        await this._patchPersist({
            chunk: this.chunkJSON()
        }, "chunk", (res: any) => {
            console.log(res);
            if (res && res.updated && res.updated.linkedCardID) {
                this.linkedCardID = res.updated.linkedCardID;
            }
        });

    }
}

export { QuizObjectChunk };
export type { IQuizObjectChunk};